module.exports = __webpack_public_path__ + "img/信息流.cefe739e.svg";